import { render, staticRenderFns } from "./HrDocumentUpdateAvailableModal.vue?vue&type=template&id=44bd6715&scoped=true&"
import script from "./HrDocumentUpdateAvailableModal.vue?vue&type=script&lang=js&"
export * from "./HrDocumentUpdateAvailableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bd6715",
  null
  
)

export default component.exports